/* Imports */
import React, { useState } from "react"
import { DropdownContainer, Dropdown, Button } from "fajny-react"
import { Link } from "react-router-dom"

import ComponentPage from "../../components/ComponentPage"
import DemoItem from "../../components/DemoItem"

const DropdownPage = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [isRightOpen, setIsRightOpen] = useState(false)

    const items = [
        {
            title: "Justify left",
            content: (
                <DropdownContainer justify="left">
                    <Button onClick={() => setIsOpen(!isOpen)}>Open dropdown</Button>

                    <Dropdown isOpen={isOpen}>
                        <Link to="#">Link</Link>
                        <Link to="#">Link</Link>
                        <button>Button</button>
                        <button>Button</button>
                    </Dropdown>
                </DropdownContainer>
            ),
            code: 'const [isOpen, setIsOpen] = useState(false)\n\n<DropdownContainer justify="left">\n    <Button onClick={() => setIsOpen(!isOpen)}>Open dropdown</Button>\n\n    <Dropdown isOpen={isOpen}>\n        <Link to="#">Link</Link>\n        <Link to="#">Link</Link>\n        <button>Button</button>\n        <button>Button</button>\n    </Dropdown>\n</DropdownContainer>',
        },
        {
            title: "Justify right",
            content: (
                <DropdownContainer justify="right">
                    <Button onClick={() => setIsRightOpen(!isRightOpen)}>Open dropdown</Button>

                    <Dropdown isOpen={isRightOpen}>
                        <Link to="#">Link</Link>
                        <Link to="#">Link</Link>
                        <button>Button</button>
                        <button>Button</button>
                    </Dropdown>
                </DropdownContainer>
            ),
            code: 'const [isRightOpen, setIsRightOpen] = useState(false)\n\n<DropdownContainer justify="right">\n    <Button onClick={() => setIsRightOpen(!isRightOpen)}>Open dropdown</Button>\n\n    <Dropdown isOpen={isRightOpen}>\n        <Link to="#">Link</Link>\n        <Link to="#">Link</Link>\n        <button>Button</button>\n        <button>Button</button>\n    </Dropdown>\n</DropdownContainer>',
        },
    ]

    const propsItems = [
        {
            name: "justify (DropdownContainer)",
            type: "String",
            example: "right",
            possible: '"left" | "right"',
            default: "left",
        },
        {
            name: "isOpen (Dropdown)",
            type: "Boolean",
        },
    ]

    return (
        <ComponentPage propsItems={propsItems}>
            <DemoItem demo={items[0]} />
            <DemoItem demo={items[1]} />
        </ComponentPage>
    )
}

export default DropdownPage
